import { request } from "@/utils/request"

export function createOrder(data) {
    return request({
        url: "api/advertising/lazada/create",
        method: "post",
        data
    })
}
export function getListOrder(queries = "") {
    return request({
        url: "api/advertising/lazada" + queries,
        method: "get"
    })
}

export function removeOrder(data) {
    return request({
        url: "api/advertising/lazada/remove",
        method: "post",
        data
    })
}
